// https://www.zachsnoek.com/blog/creating-custom-react-hooks-useconfirmtabclose
import { useEffect } from 'react';

const DEFAULT_MSG = 'You have unsaved changes. Continue?';

type Props = { when: boolean; message?: string };

export function useConfirmTabClose({ when, message = DEFAULT_MSG }: Props) {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (when) {
        event.preventDefault();
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when, message]);
}
